import React, { useState } from "react";
import i18n from "i18n";

import { StockService } from "../../../../../services/StockService";

import Icon from "components/MainApp/atoms/Icon/icon";

import ItemStockReadingTableItem from "./ItemStock";

import styles from "./ItemStockReadingTable.module.scss";

const ItemStockReadingTable = ({
  stock,
  headers,
  headerClickHandler,
  handleClickProduct,
  tagsInMov = [],
  businessId,
  userId,
  locationIds,
  originalStock,
  collectAuditDetails
}) => {
  const renderHeaderItem = (key, index) => {
    return (
      <div
        key={index}
        data-automation-id={`sort-by-${key}`}
        onClick={() => {
          headerClickHandler(key);
        }}
        data-filter-name={key}
        className={`${styles["stock-reading-table-header-item"]} ${
          styles[`stock-reading-table-header-${key}`]
        }`}
      >
        {headers[key].title}
        <span className={styles[`stock-reading-table-header-icon-span`]}>
          {" "}
        </span>
      </div>
    );
  };
  const table = (
    <React.Fragment>
      <div
        className={styles["stock-reading-table-desktop"]}
        data-automation-id="stock-table"
      >
        <div className={styles["stock-reading-table-header"]}>
          {Object.keys(headers).map((key, index) =>
            renderHeaderItem(key, index)
          )}
          <div
            className={`${styles["stock-reading-table-header-item"]} ${styles["stock-reading-table-header-button"]}`}
          ></div>
        </div>
        <div className={styles["stock-reading-table-content"]}>
          {stock?.map((stockItem, index, array) => {
            let separatorText = "";
            if (stockItem.expectedUnits === 0) {
              separatorText = i18n.t("wrong.tags");
            } else if (stockItem.readItems === stockItem.expectedUnits) {
              separatorText = i18n.t("successful.audits");
            } else if (stockItem.readItems !== stockItem.expectedUnits) {
              separatorText = i18n.t("incorrect.audits");
            }

            const prevItem = array[index - 1];
            let prevSeparatorText = "";
            if (prevItem) {
              if (prevItem.expectedUnits === 0) {
                prevSeparatorText = i18n.t("wrong.tags");
              } else if (prevItem.readItems === prevItem.expectedUnits) {
                prevSeparatorText = i18n.t("successful.audits");
              } else if (prevItem.readItems !== prevItem.expectedUnits) {
                prevSeparatorText = i18n.t("incorrect.audits");
              }
            }

            const isLastItem = index === array.length - 1;

            const isGroupStart =
              index === 0 || separatorText !== prevSeparatorText;

            return (
              <React.Fragment key={stockItem.id}>
                {isGroupStart && (
                  <p className={styles["text-separator"]}>{separatorText}</p>
                )}
                <div className={styles["stock-reading-table-content-item"]}>
                  <ItemStockReadingTableItem
                    stock={stockItem}
                    list={stockItem.tags}
                    tagsInMov={tagsInMov}
                    originalStock={originalStock}
                    collectAuditDetails={collectAuditDetails}
                    isLastItem={isLastItem}
                  />
                </div>
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </React.Fragment>
  );

  const noitems = (
    <div className={styles["stock-reading-table-no-items"]}>
      <Icon name="stock" fill="#3C7AF5" width={87} height={65}></Icon>
      <h1>{i18n.t("no.results")}</h1>
    </div>
  );

  return (
    <div className={styles["stock-reading-table-container"]}>
      {stock.length > 0 ? table : noitems}
    </div>
  );
};

export default ItemStockReadingTable;
